/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are the circles sized by set size?`)
};

const es_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Los círculos tienen el tamaño según el tamaño del conjunto?`)
};

const de_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind die Kreise nach Mengengröße skaliert?`)
};

const nl_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn de cirkels geschaald naar de setgrootte?`)
};

const fr_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les cercles sont-ils dimensionnés selon la taille de l'ensemble ?`)
};

const it_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I cerchi sono dimensionati in base alla dimensione dell'insieme?`)
};

const pt_br2_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os círculos são dimensionados pelo tamanho do conjunto?`)
};

const pt_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os círculos têm o tamanho proporcional ao conjunto?`)
};

const ja_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`円は集合の大きさに応じたサイズですか?`)
};

const zh_venn_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圆圈的大小是否按集合大小确定？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_q3", locale)
	if (locale === "en") return en_venn_faq_q3(inputs)
	if (locale === "es") return es_venn_faq_q3(inputs)
	if (locale === "de") return de_venn_faq_q3(inputs)
	if (locale === "nl") return nl_venn_faq_q3(inputs)
	if (locale === "fr") return fr_venn_faq_q3(inputs)
	if (locale === "it") return it_venn_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_q3(inputs)
	if (locale === "pt") return pt_venn_faq_q3(inputs)
	if (locale === "ja") return ja_venn_faq_q3(inputs)
	return zh_venn_faq_q3(inputs)
};